//@ts-nocheck

'use client'

import React, { useEffect, useState } from 'react'

import * as S from './PhotoList.styles'

import Image from 'next/image'
import Spinner from '../../atoms/Spinner/Spinner.component'
import { Heading } from '../../atoms/Typography/Typography.component'
import { SpacerBase } from '../../atoms/GridSystem'
import ModalPhoto from '../../molecules/Modal/ModalPhoto/ModalPhoto.component'
import { useModal } from '../../../contexts/Modal.context'
import { useTranslations } from 'next-intl'

const PhotoList = ({ accessToken, contestId, getUserUploadedPhotos }) => {
  const [photos, setPhotos] = useState([])
  const [loading, setLoading] = useState(true)
  const { showModal } = useModal()
  const t = useTranslations()

  const calculateImageRatio = (width, height) => {
    if (!width || !height) {
      return '0 / 0';
    }
    
    // Calcola il massimo comune divisore (MCD)
    const calculateGCD = (a, b) => {
      return b === 0 ? a : calculateGCD(b, a % b);
    };
    
    const gcd = calculateGCD(width, height);
    
    // Semplifica il rapporto dividendo per il MCD
    const simplifiedWidth = width / gcd;
    const simplifiedHeight = height / gcd;
    
    return `${simplifiedWidth} / ${simplifiedHeight}`;
  };

  useEffect(() => {
    const fetchPhotos = async () => {
      try {
        const photos = await getUserUploadedPhotos(contestId, accessToken)
        setPhotos(photos)
        setLoading(false)
      } catch (error) {
        console.error('Errore durante il recupero delle foto:', error)
        setLoading(false)
      }
    }

    fetchPhotos()
  }, [accessToken, contestId])

  return (
    <S.PhotoList>
      <Heading
        content={t('privateArea.submissionsListTitle')}
        as="h1"
        typo="headingXXL"
        weight="medium"
      />
      <SpacerBase xs={3} />
      {loading && <Spinner /> }
      { !loading && photos.length > 0 ? (
        <S.PhotoListWrapper>
          { photos.map(({title, photo}, index) => {
            const aspectRatio = calculateImageRatio(photo?.width, photo?.height)

            return (
              <S.PhotoListImageWrapper 
                key={index} 
                aspectRatio={aspectRatio}
                onClick={() => {
                  showModal( ModalPhoto, {
                    title,
                    image: photo,
                    aspectRatio,
                    foreground: true
                  })
                }}
              >
                <Image
                  src={photo?.url}
                  alt={photo?.alternativeText}
                  fill
                />
                <S.PhotoListImageTitle>
                  <Heading 
                    content={title}
                    as="h2"
                    typo="headingSM"
                    weight="medium"
                  />
                </S.PhotoListImageTitle>
              </S.PhotoListImageWrapper>
            )
          })}
        </S.PhotoListWrapper>
      ) : (
        <S.PhotoListWrapper>
          <Heading 
            content={t('privateArea.submissionsListEmpty')}
            as="h2"
            typo="headingSM"
            weight="medium"
          />
        </S.PhotoListWrapper>
      )}
    </S.PhotoList>
  )
}

export default PhotoList
